import { queryOptions } from '@tanstack/react-query'
import { Pagination } from '@thinknimble/tn-models'
import { statementApi } from './api'
import { StatementFilter } from './models'

export const statementQueries = {
  all: () => ['statements'],
  list: ({
    filters,
    pagination,
    paginationCallback,
  }: {
    filters?: Partial<StatementFilter>
    pagination?: Pagination
    paginationCallback?: (pagination: Pagination) => void
  } = {}) => {
    return queryOptions({
      queryKey: [...statementQueries.all(), { filters, pagination }],
      queryFn: async () => {
        const res = await statementApi.list({
          filters,
          pagination,
        })
        const serverPagination = new Pagination({ ...res, totalCount: res.count })
        paginationCallback?.(serverPagination)
        return res
      },
    })
  },
  retrieve: (id: string) => {
    return queryOptions({
      queryKey: [...statementQueries.all(), id],
      queryFn: () => statementApi.retrieve(id),
      enabled: Boolean(id),
    })
  },
  rows: (statementId: string) => {
    return queryOptions({
      queryKey: [...statementQueries.all(), statementId, 'rows'],
      queryFn: () => statementApi.csc.listRows(statementId),
      enabled: Boolean(statementId),
    })
  },
  columnPreview: (statementId: string, enabled = true) => {
    return queryOptions({
      queryKey: [...statementQueries.all(), statementId, 'column-preview'],
      queryFn: () => statementApi.csc.columnPreview(statementId),
      enabled: Boolean(statementId) && enabled,
    })
  },
}
